(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-estimator"] && !Shopify.designMode) return;
  try {
    
  // Defined once per page. Re-upgrades automatically when the theme editor
  // re-renders the section, which a plain IIFE would not survive.
  if (!customElements.get('wedding-estimator')) {
    customElements.define('wedding-estimator', class WeddingEstimator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.feeRate = (parseFloat(this.dataset.feePercent) || 0) / 100;
        this.feeMin = parseFloat(this.dataset.feeMin) || 0;
        this.currency = this.dataset.currency || '$';

        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-wq-row]'));
        this.dateInput = this.querySelector('[data-wq-date]');

        this.rows.forEach(this.bindRow.bind(this));

        if (this.dateInput) {
          this.dateInput.addEventListener('change', this.render.bind(this));
          this.dateInput.addEventListener('input', this.render.bind(this));
        }

        var clear = this.querySelector('[data-wq-clear]');
        if (clear) {
          clear.addEventListener('click', function () {
            this.rows.forEach(function (row) {
              row.querySelector('[data-wq-qty]').value = 0;
            });
            this.render();
          }.bind(this));
        }

        var ackOk = this.querySelector('[data-wq-ack-ok]');
        if (ackOk) {
          ackOk.addEventListener('click', function () {
            this.querySelector('[data-wq-ack]').hidden = true;
          }.bind(this));
        }

        // Shopify reloads the page after a successful post, landing the viewer
        // back at the top with the form reset far below. Switch the section to
        // its sent state and bring the confirmation to them.
        var success = this.querySelector('.wq-success');
        if (success) {
          this.dataset.posted = 'true';
          try {
            success.scrollIntoView({ block: 'center' });
          } catch (e) {
            success.scrollIntoView();
          }
          success.focus();
        }

        this.render();
      }

      bindRow(row) {
        var qty = row.querySelector('[data-wq-qty]');
        var minus = row.querySelector('[data-wq-minus]');
        var plus = row.querySelector('[data-wq-plus]');

        var step = function (delta) {
          var v = parseInt(qty.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          qty.value = Math.max(0, v + delta);
          this.render();
        }.bind(this);

        if (minus) minus.addEventListener('click', function () { step(-1); });
        if (plus) plus.addEventListener('click', function () { step(1); });
        if (qty) qty.addEventListener('input', this.render.bind(this));
      }

      // ---------- helpers ----------
      money(n) {
        return this.currency + Math.round(n).toLocaleString('en-US');
      }

      range(lo, hi) {
        if (Math.round(lo) === Math.round(hi)) return this.money(lo);
        return this.money(lo) + ' – ' + this.money(hi);
      }

      // Month of the wedding, 1-12, or null when no usable date is entered.
      weddingMonth() {
        if (!this.dateInput || !this.dateInput.value) return null;
        var parts = this.dateInput.value.split('-');
        if (parts.length !== 3) return null;
        var m = parseInt(parts[1], 10);
        return (m >= 1 && m <= 12) ? m : null;
      }

      monthName(m) {
        var names = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                     'August', 'September', 'October', 'November', 'December'];
        return names[m - 1] || 'that month';
      }

      // A seasonal item is unavailable when the wedding month falls outside its
      // window. With no date entered we cannot rule it out, so it stays on.
      rowAvailable(row) {
        if (row.dataset.seasonal !== '1') return true;
        var m = this.weddingMonth();
        if (m === null) return true;
        var from = parseInt(row.dataset.seasonFrom, 10);
        var to = parseInt(row.dataset.seasonTo, 10);
        if (isNaN(from) || isNaN(to)) return true;
        // A window that wraps the year end (e.g. 11 to 2) is still handled.
        if (from <= to) return m >= from && m <= to;
        return m >= from || m <= to;
      }

      feeFor(subtotal) {
        if (subtotal <= 0) return 0;
        return Math.max(this.feeMin, subtotal * this.feeRate);
      }

      // ---------- the one pass ----------
      render() {
        var removed = [];
        var minSub = 0, maxSub = 0, chosen = [], needsDelivery = false;

        this.rows.forEach(function (row) {
          var qtyEl = row.querySelector('[data-wq-qty]');
          var ok = this.rowAvailable(row);
          var qty = parseInt(qtyEl.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;

          // Out of season the item is not orderable: clear it and disable the
          // stepper, so it can never reach the total.
          if (!ok) {
            if (qty > 0) {
              removed.push({ label: row.dataset.label, qty: qty });
              qty = 0;
              qtyEl.value = 0;
            }
            qtyEl.disabled = true;
          } else {
            qtyEl.disabled = false;
          }
          row.querySelectorAll('[data-wq-minus], [data-wq-plus]').forEach(function (b) {
            b.disabled = !ok;
          });
          row.dataset.wqUnavailable = ok ? 'false' : 'true';
          row.dataset.wqChosen = qty > 0 ? 'true' : 'false';

          var lo = (parseFloat(row.dataset.min) || 0);
          var hi = (parseFloat(row.dataset.max) || 0);
          row.querySelector('[data-wq-price]').textContent = this.range(lo, hi);

          if (qty > 0) {
            if (row.dataset.pickup !== '1') needsDelivery = true;
            minSub += lo * qty;
            maxSub += hi * qty;
            chosen.push({ label: row.dataset.label, qty: qty, lo: lo * qty, hi: hi * qty });
          }
        }.bind(this));

        var minFee = needsDelivery ? this.feeFor(minSub) : 0;
        var maxFee = needsDelivery ? this.feeFor(maxSub) : 0;
        var pickupOnly = chosen.length > 0 && !needsDelivery;

        this.paintLedger(chosen, minSub, maxSub, minFee, maxFee, pickupOnly);
        this.paintForm(chosen, minSub, maxSub, minFee, maxFee, pickupOnly);
        this.paintAvailability(removed);
      }

      paintLedger(chosen, minSub, maxSub, minFee, maxFee, pickupOnly) {
        var picked = this.querySelector('[data-wq-picked]');
        picked.textContent = '';
        if (!chosen.length) {
          var p = document.createElement('p');
          p.className = 'wq-empty';
          p.textContent = 'Add the pieces you need and your estimate appears here.';
          picked.appendChild(p);
        } else {
          chosen.forEach(function (c) {
            var row = document.createElement('div');
            row.className = 'wq-picked-row';
            var a = document.createElement('span');
            a.textContent = c.qty + ' × ' + c.label;
            var b = document.createElement('span');
            b.textContent = this.range(c.lo, c.hi);
            row.appendChild(a); row.appendChild(b);
            picked.appendChild(row);
          }.bind(this));
        }

        this.querySelector('[data-wq-flowers]').textContent =
          minSub ? this.range(minSub, maxSub) : '—';
        this.querySelector('[data-wq-fee]').textContent =
          pickupOnly ? 'Pickup' : (minFee ? this.range(minFee, maxFee) : '—');
        this.querySelector('[data-wq-total]').textContent =
          (minSub + minFee) ? this.range(minSub + minFee, maxSub + maxFee) : '—';

        var note = this.querySelector('[data-wq-feenote]');
        var pct = Math.round(this.feeRate * 100);
        var floor = this.money(this.feeMin);
        if (pickupOnly) {
          note.textContent = 'Collected from the farm, so there is no delivery or setup fee. Add anything we arrange and the usual fee applies.';
        } else if (!minSub) {
          note.textContent = 'Delivery and setup is ' + pct + '% of the flowers total, minimum ' + floor + '.';
        } else if (minFee === this.feeMin && maxFee === this.feeMin) {
          note.textContent = 'Delivery and setup is our ' + floor + ' minimum here. It becomes ' + pct + '% on larger orders.';
        } else {
          note.textContent = 'Delivery and setup is ' + pct + '% of the flowers total, minimum ' + floor + '. Includes delivery, on-site setup and collection.';
        }
      }

      // Writes the posted fields. Read-only and visible, so nothing is sent
      // that the couple has not seen.
      paintForm(chosen, minSub, maxSub, minFee, maxFee, pickupOnly) {
        var lines = [];
        if (!chosen.length) {
          lines.push('(nothing selected yet)');
        } else {
          chosen.forEach(function (c) {
            lines.push(c.qty + ' x ' + c.label + '  -  ' + this.range(c.lo, c.hi));
          }.bind(this));
        }

        var flowers = minSub ? this.range(minSub, maxSub) : '-';
        var fee = pickupOnly ? 'Pickup from the farm, no fee'
                             : (minFee ? this.range(minFee, maxFee) : '-');
        var total = (minSub + minFee) ? this.range(minSub + minFee, maxSub + maxFee) : '-';

        var items = this.querySelector('[data-wq-items]');
        if (items) {
          items.value = lines.join('\n') +
            '\n\nFlowers:          ' + flowers +
            '\nDelivery & setup: ' + fee +
            '\nEstimated total:  ' + total +
            '\n\nEstimate generated on the website. Not a quote.';
        }

        var set = function (sel, val) {
          var el = this.querySelector(sel);
          if (el) el.value = val;
        }.bind(this);
        set('[data-wq-hidden-flowers]', flowers);
        set('[data-wq-hidden-fee]', fee);
        set('[data-wq-hidden-total]', total);
      }

      paintAvailability(removed) {
        // Standing note: names any item the current date rules out.
        var unavailable = this.rows.filter(function (row) {
          return row.dataset.wqUnavailable === 'true';
        });
        var avail = this.querySelector('[data-wq-avail]');
        if (avail) {
          if (unavailable.length) {
            avail.textContent = unavailable.map(function (r) { return r.dataset.label; })
              .join(', ') + ': not available for your date.';
            avail.hidden = false;
          } else {
            avail.hidden = true;
          }
        }

        // One-off acknowledgement: only when something was actually taken out.
        var ack = this.querySelector('[data-wq-ack]');
        var ackText = this.querySelector('[data-wq-ack-text]');
        if (!ack || !ackText) return;

        if (removed.length) {
          var m = this.weddingMonth();
          var parts = removed.map(function (r) { return r.qty + ' × ' + r.label; });
          ackText.textContent = parts.join(' and ') +
            ' came off your list — not available in ' +
            (m ? this.monthName(m) : 'that month') + '.';
          ack.hidden = false;
        } else if (!unavailable.length) {
          // Date moved back into season, so the notice is stale.
          ack.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
